import { createFileRoute, redirect } from '@tanstack/react-router';

import { useAttributionParams } from '@/features/attribution/model';
import { useNavState } from '@/lib/nav-state';
import { OrderJourneyScreen } from '@/screens/attribution/OrderJourneyScreen';

/** The row and the order come from history state, not the URL; without them, back to the list. */
export const Route = createFileRoute('/_app/attribution/order')({
  beforeLoad: ({ location }) => {
    if (!location.state.entity || !location.state.orderId)
      throw redirect({ to: '/attribution', replace: true });
  },
  component: OrderRoute,
});

function OrderRoute() {
  const { entity, orderId } = useNavState();
  // The crumbs come from the drawer that opened the order (page state, not the URL).
  const { order } = useAttributionParams();
  if (!entity || !orderId) return null;
  return (
    <OrderJourneyScreen
      level={entity.kind}
      id={entity.id}
      orderId={orderId}
      name={order?.name}
      slice={order?.slice}
      back={order?.back}
    />
  );
}
